import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import PickupOrderDriver from './PickupOrderDriver';

import User from '../../../models/User';
import ApiResponse from '../../../models/ApiResponse';
import PickupOrder from '../../../models/PickupOrder';
import ResponseError from '../../../models/ResponseError';

import { PO_SCHEMA } from '../../../utils/pickupOrder';
import { handlePrintPickupOrder } from '../../../utils/printing';

interface PickupOrderDriverContainerProps {
  user: User;
  history: any;
  match: { params: { poNumber: string, secretKey: string } };
  receiveError: (error: ResponseError) => void;
  receiveSuccess: (message: string) => void;
};

interface PickupOrderDriverContainerState {
  po: PickupOrder;
  poNumber: string;
  secretKey: string;
};

class PickupOrderDriverContainer extends Component<PickupOrderDriverContainerProps, PickupOrderDriverContainerState> {

  state = {
    po: PO_SCHEMA,
    poNumber: '',
    secretKey: ''
  }

  componentDidMount() {

    const poNumber: string = this.props.match.params.poNumber;
    const secretKey: string = this.props.match.params.secretKey;

    pickupOrderRemote.getPickupOrder(poNumber, secretKey).then((resp: ApiResponse<PickupOrder>) => {

      const po: PickupOrder | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {
        
        const pickOr: PickupOrder = { ...po };
        pickOr.pickup_time = po.latest_eta;
       
        this.setState({ po: pickOr, poNumber, secretKey });
      }

      if (error) {
        this.props.receiveError(error);
      };
    })
  }


  doCheckIn = (): void => {

    const poNumber: string = this.state.poNumber;
    const secretKey: string = this.state.secretKey;

    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords;
        this.sendCheckInRequest(poNumber, secretKey, {lat: latitude, lng: longitude});
      },
      () => {
        this.props.receiveError({errorCode: '', longDescription: 'You need to enable the location of your device in order to use that feature.'});
      }
    );  
  }

  sendCheckInRequest = (poNumber: string, secretKey: string, location?: { lat: number, lng: number}) => {
    
    pickupOrderRemote.driverCheckIn(poNumber, secretKey, location).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        this.props.receiveSuccess('Checked In.');
        this.setState({po: { ...this.state.po, driver_checkin_time: "0000" }});
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  selectETA = (): void => {

    const currState: PickupOrderDriverContainerState = { ...this.state };
    const poNumber: string = currState.poNumber;
    const secretKey: string = currState.secretKey;
    
    if (poNumber && secretKey) {
      this.props.history.push(`/drv-map/po/${poNumber}/${secretKey}`);
    }
  }

  printPickupOrder = (): void => {

    const poNumber: string = this.state.poNumber;
    const secret: string | undefined = this.props.user.roleId !== 0 ? undefined : this.state.secretKey;

    if (poNumber) {
      handlePrintPickupOrder(poNumber, secret);
    }
  }

  render() {

    return (
      <PickupOrderDriver
        pickupOrder={ this.state.po }
        doCheckIn={ this.doCheckIn }
        selectETA={ this.selectETA }
        printPickupOrder={ this.printPickupOrder }
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(PickupOrderDriverContainer);